/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { createColorsContext } from "@superweb/ui";

const [TableRowSeverityColors, useTableRowSeverityColors] =
  createColorsContext<{
    group: string;
    medium: string;
    hard: string;
    total: string;
  }>({
    light: {
      group: "#FBFBFB",
      medium: "#F6F6F6",
      hard: "#F2F2F2",
      total: "#FBFBFB",
    },
    dark: {
      group: "#343330",
      medium: "#373634",
      hard: "#3B3A37",
      total: "#333230",
    },
  });
export { TableRowSeverityColors, useTableRowSeverityColors };
